export default context => {
    const moduleId = context.getters.moduleId;
    const parentId = moduleId.substring(0, moduleId.indexOf('_'));

    const startDateId = `${moduleId}_start-date`;
    context.dispatch('complaintDurationCustomValidation', {
        root: true,
    }).then(() => {
        if (context.rootState[startDateId].value.length > 0) {
            context.commit(`${parentId}/ADD_TRACKED_ERRORS`, [
                startDateId,
            ], {
                root: true,
            });
        } else {
            context.commit(`${parentId}/REMOVE_TRACKED_ERRORS`, [
                startDateId,
            ], {
                root: true,
            });
        }
    });
};